import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { createChat, editChat } from '~/config/routes';
import List from './List';
import Edit from './Edit';
import New from './New';
import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';

function Chat() {
  return (
    <Switch>
      <Route
        exact
        path={createChat.spec}
        render={(props) => (
          <>
            <Can I="new" a="Chats">
              {() => <New {...props} />}
            </Can>
            <Can not I="new" a="Chats">
              {() => <NotPermissionPage />}
            </Can>
          </>
        )}
      />
      <Route
        exact
        path={editChat.spec}
        render={(props) => (
          <>
            <Can I="edit" a="Chats">
              {() => <Edit {...props} />}
            </Can>
            <Can not I="edit" a="Chats">
              {() => <NotPermissionPage />}
            </Can>
          </>
        )}
      />
      <Route
        render={(props) => (
          <>
            <Can I="list" a="Chats">
              {() => <List {...props} />}
            </Can>
            <Can not I="list" a="Chats">
              {() => <NotPermissionPage />}
            </Can>
          </>
        )}
      />
    </Switch>
  );
}
export default Chat;
